import React from "react";
import styles from "./MediaCard.module.scss";

const MediaCard = () => {
  return (
    <div className={styles.card} onClick={() => console.log("Card clicked.")}>
      <h2 className={styles.title}>Life Of One Artists</h2>
      <p className={styles.description}>
        Belief, Lorem Ipsum is not simply random text. It has roots in a piece
        of classical Latin literature from 45 BC, making it over 2000 years old.
        Belief, Lorem Ipsum is not simply random text. It has roots in a piece
        of classical Latin literature from 45 BC.
      </p>
      <div className={styles.date}>18 Aug, 2024</div>
    </div>
  );
};

export default MediaCard;
